/**
 * Ce fichier permets de créer les différentes variables qu'on utilise dans des
 * différentes fichiers
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import { devicesReducer as devices } from './devices';
import { eventsReducer as events } from './events';
import { geofencesReducer as geofences } from './geofences';
import { groupsReducer as groups } from './groups';
import { positionsReducer as positions } from './positions';
import { reportRouteReducer as reportRoute } from './reportRoute';
import { reportTripsReducer as reportTrips } from './reportTrips';
import { sessionReducer as session } from './session';
import { usersReducer as users } from './users';
import { summaryReducer as summary } from './summary';
import { summaryPilotReducer as summaryPilot } from './summaryPilot';
import { aerosReducer as aeros } from './aeros';
import { pointReducer as point } from './point';

/*-------------------------------------------------------------------------------------------*/

const reducer = combineReducers({
  session,
  devices,
  positions,
  users,
  reportRoute,
  groups,
  reportTrips,
  events,
  geofences,
  summary,
  summaryPilot,
  aeros,
  point
});

/*-------------------------------------------------------------------------------------------*/

export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from './positions';
export { usersActions } from './users';
export { reportRouteActions } from './reportRoute';
export { groupsActions } from './groups';
export { reportTripsActions } from './reportTrips';
export { eventsActions } from './events';
export { geofencesActions } from './geofences';
export { summaryAction } from './summary';
export { summaryPilotAction } from './summaryPilot';
export { aerosActions } from './aeros';
export { pointActions } from './point';

export default configureStore({ reducer, middleware: [thunk] });
/*-------------------------------------------------------------------------------------------*/
